import React from 'react';

const Cart = () => {
    return null;
}

export default Cart;
